import { object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

export default () => {
    const { REQUIRED_TEXT } = getValidationTexts();
    return object().shape({
        first_name: string().required(REQUIRED_TEXT).nullable(),
        last_name: string().required(REQUIRED_TEXT).nullable(),
    });
};
